import { Component, Input, OnInit } from '@angular/core';
import { availableSubjects, default_subjectIcon_path, subjectIcon_path } from 'projects/selflearnv2-ui/src/app/constants/app.constants';


@Component({
  selector: 'app-iconic-subject',
  templateUrl: './iconic-subject.component.html',
  styleUrls: ['./iconic-subject.component.css']
})
export class IconicSubjectComponent implements OnInit {

  @Input() subjectID: number;
  @Input() subjectName: string;
  @Input() icon:any;
  subjectNameWithoutSpace: string;

  constructor() { }

  getSubjectIconName(subjectName:any){
    const found = availableSubjects.find((element:any) => element.toLowerCase() == subjectName.toLowerCase());
    return (found) ? subjectIcon_path + found
    : default_subjectIcon_path;
  }
  getSubjectIcon(subjectName:any){
    const found = availableSubjects.find((element:any) => element.toLowerCase() == subjectName.toLowerCase());
    return (found) ? subjectIcon_path + found + '-new-icon.svg' 
      : default_subjectIcon_path +'.svg';
  }

  ngOnInit(): void {
    this.subjectNameWithoutSpace = this.subjectName.replace(/\s/g, "");
  }

}
